import DesignPlanningMarquee from "./DesignPlanningMarquee";
import { DynamicMarquee } from "./DynamicMarquee";

const skills = [
  {
    name: "CraftCMS",
    username: "@craftcms",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-400 text-white rounded'>CMS</span> A modern CMS I’ve only used on a few projects, but it offers a clean and flexible approach.",
    img: "./craftcms.png",
  },
  {
    name: "Drupal",
    username: "@drupal",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-400 text-white rounded'>CMS</span> Back in the day, it was far better than Joomla, but demand has decreased over time.",
    img: "./drupal.png",
  },
  {
    name: "Joomla",
    username: "@joomla",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-400 text-white rounded'>CMS</span> In its early days, Joomla was the go-to choice for many websites.",
    img: "./joomla.png",
  },
  {
    name: "WordPress",
    username: "@wordpress",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-400 text-white rounded'>CMS</span> The CMS I’ve worked with the most—used on the majority of my projects.",
    img: "./wordpress.svg",
  },
  {
    name: "Other CMS",
    username: "@othercms",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-400 text-white rounded'>CMS</span> <strong>Concrete5</strong>, <strong>Typo3</strong>, <strong>MediaWiki</strong>, <strong>CMSMS</strong> — worked on various niche projects using these platforms.",
    img: "./php.svg",
  },
  {
    name: "Magento",
    username: "@magento",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-600 text-white rounded'>Ecommerce</span> Used only on a few projects, but powerful for large-scale online stores.",
    img: "./magento.svg",
  },
  {
    name: "OSCommerce",
    username: "@oscommerce",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-600 text-white rounded'>Ecommerce</span> Popular back in the day, often the default choice for PHP-based ecommerce sites.",
    img: "./oscommerce.png",
  },
  {
    name: "WooCommerce",
    username: "@woocommerce",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-600 text-white rounded'>Ecommerce</span> A WordPress plugin that’s now one of the most widely used ecommerce solutions.",
    img: "./woocommerce.svg",
  },
  {
    name: "CakePHP",
    username: "@cakephp",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-800 text-white rounded'>Framework</span> The first framework I loved using—MVC structure and console commands allowed me to create custom CMS solutions.",
    img: "./cakephp.svg",
  },
  {
    name: "CodeIgniter",
    username: "@codeigniter",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-800 text-white rounded'>Framework</span> Lightweight and fast, used in a handful of projects.",
    img: "./codeigniter.svg",
  },
  {
    name: "Symfony",
    username: "@symfony",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-800 text-white rounded'>Framework</span> Very strict with standards—great for large collaborative teams but less flexible for personal coding styles.",
    img: "./symfony.svg",
  },
  {
    name: "Laravel",
    username: "@laravel",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-800 text-white rounded'>Framework</span> Since 2015, my favorite PHP framework—powerful, flexible, and suitable for almost any type of project.",
    img: "./laravel.svg",
  },
  {
    name: "Yii",
    username: "@yii",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-800 text-white rounded'>Framework</span> Easy-to-use MVC structure, though I’ve only worked with it once.",
    img: "./yii.png",
  },
  {
    name: "Custom Framework",
    username: "@customframework",
    category: "PHP",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-800 text-white rounded'>Framework</span> Built a framework with a collaborator inspired by Kohana to explore MVC approach in PHP architecture.",
    img: "./php.svg",
  },
  // Python - Desktop
  {
    name: "PyQt",
    username: "@pyqt",
    category: "Python",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-600 text-white rounded'>Desktop</span> My preferred toolkit for creating cross-platform desktop apps on macOS, Windows, and Linux.",
    img: "./qt.png",
  },
  {
    name: "Tkinter",
    username: "@tkinter",
    category: "Python",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-600 text-white rounded'>Desktop</span> Simple and lightweight for basic GUIs, though I use PyQt for more advanced needs.",
    img: "./tkinter.png",
  },

  // Python - Frameworks
  {
    name: "Django",
    username: "@django",
    category: "Python",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-800 text-white rounded'>Framework</span> A favorite for its robustness, scalability, and speed in building full-featured apps.",
    img: "./django.svg",
  },
  {
    name: "Flask",
    username: "@flask",
    category: "Python",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-800 text-white rounded'>Framework</span> My go-to for small APIs—ideal for quick CRUD and authentication services.",
    img: "./flask.svg",
  },
  {
    name: "FastAPI",
    username: "@fastapi",
    category: "Python",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-800 text-white rounded'>Framework</span> <span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-red-800 text-white rounded'>Recent</span> My current choice for AI prototypes and experimental APIs—fast, modern, and easy to use.",
    img: "./fast-api.svg",
  },

  // Ruby - CMS
  {
    name: "Redmine",
    username: "@redmine",
    category: "Ruby",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-400 text-white rounded'>CMS</span> A project-management CMS I’ve deployed on Heroku with PostgreSQL—excellent for collaboration.",
    img: "./redmine.png",
  },
  {
    name: "RefineryCMS",
    username: "@refinerycms",
    category: "Ruby",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-400 text-white rounded'>CMS</span> A Rails-based CMS I used for a project preloaded with users and articles.",
    img: "./refinery.png",
  },

  // Ruby - Frameworks
  {
    name: "Rails",
    username: "@rails",
    category: "Ruby",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-800 text-white rounded'>Framework</span> The framework that introduced me to MVC—innovative and hugely influential in web development.",
    img: "./rails.svg",
  },

  // C# - Desktop
  {
    name: "WinForms",
    username: "@winforms",
    category: "C#",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-600 text-white rounded'>Desktop</span> Stable, mature, and rich in UI components—used since 2008 for utility apps.",
    img: "./winform.png",
  },
  {
    name: "WPF",
    username: "@wpf",
    category: "C#",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-600 text-white rounded'>Desktop</span> My preferred choice for modern C# UIs—far more flexible than WinForms.",
    img: "./wpf.png",
  },

  // C# - Mobile
  {
    name: "Xamarin",
    username: "@xamarin",
    category: "C#",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-600 text-white rounded'>Mobile</span> Used since 2017 for cross-platform apps without a Mac—now deprecated.",
    img: "./xamarin.svg",
  },
  {
    name: ".NET MAUI",
    username: "@maui",
    category: "C#",
    body: "<span class='text-xxs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap font-bold bg-blue-600 text-white rounded'>Mobile</span> My current standard for building native mobile apps.",
    img: "./xamarin.svg",
  },
];

function shuffleArray(array: typeof skills) {
  const arr = [...array]; // copy to avoid modifying original
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

const firstRow = shuffleArray(skills);
//const firstRow = skills.slice(0, skills.length / 2);
//const secondRow = skills.slice(skills.length / 2);

export function BackendMarqueeContent() {
  return (
    <div className="relative flex h-[300px] flex-row items-center justify-center overflow-hidden">
      <DynamicMarquee
        items={firstRow}
        renderItem={(skill) => (
          <DesignPlanningMarquee key={skill.username} {...skill} />
        )}
        duration="40s"
      />
      {/* <DynamicMarquee
        items={secondRow}
        renderItem={(skill) => (
          <DesignPlanningMarquee key={skill.username} {...skill} />
        )}
        reverse
        duration="20s"
      /> */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-1/4 bg-gradient-to-b from-background"></div>
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/4 bg-gradient-to-t from-background"></div>
    </div>
  );
}
